import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import JsonEditor from 'components/ui/dataDisplay/JsonEditor'
import PDFViewer from 'components/ui/dataDisplay/PDFViewer'
import { getJsonEditorContent } from 'components/ui/dataDisplay/utils'
import { JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE } from 'constants/general-constants'
import React, { useEffect, useState } from 'react'
import './FilePreview.scss'
import { utilityService } from 'services/UtilityService'
import { Skeleton } from 'antd'
import otherFileIcon from 'assets/icons/other-file-icon.png'
// const jsonURL = 'https://vcms-storage-stack-dev-mediafilestorage-rcef10ph7jid.s3.amazonaws.com/0afda809-0989-4f4f-8745-8fb107178fd2_new-document-14.json'
// const pdf = 'https://vcms-storage-stack-dev-mediafilestorage-rcef10ph7jid.s3.amazonaws.com/ed5357e9-4719-427a-9432-cc6abefea8e3_file-sample150kb.pdf'
// const lottie = 'https://vcms-storage-stack-dev-mediafilestorage-rcef10ph7jid.s3.amazonaws.com/f7d699ef-47ba-42b6-8e4d-e355dbceb08f_3713696.lottie'

const getJsonFromURL = async (url) => {
  try {
    const json = await fetch(url)
    const text = await json.text()
    const jsonData = JSON.parse(text) // Manually parse JSON
    return jsonData
  } catch (err) {
    console.log('err', err)
  }
}

const mode = 'tree'
const FilePreview = ({
  type,
  url
}) => {
  const [isContentLoading, setIsContentLoading] = useState(false)
  const [stringifiedJson, setStringifiedJson] = useState(null)
  const {
    isLottieFile,
    isJsonFile,
    isPDFFile,
    isSVGFile,
    isOtherFile,
    isJpgJpegFile,
    isPNGFile
  } = utilityService.getFileTypeBooleanFlags(type)

  useEffect(() => {
    async function fetchData () {
      setIsContentLoading(true)
      const json = await getJsonFromURL(url)
      setStringifiedJson(JSON.stringify(json))
      setIsContentLoading(false)
    }
    if (isJsonFile && url) {
      fetchData()
    }
  }, [url, isJsonFile])
  const loadingSkeleton = (
    <Skeleton
      active
      avatar={{
        size: 'large',
        shape: 'default'
      }}
      title={false}
      paragraph={{
        rows: 4,
        width: '100%'
      }}
    />
  )
  return (
    <div className='file-preview'>
      {
        isLottieFile &&
        <div className='lottie-preview-wrapper'>
          <DotLottieReact src={url} loop autoplay />
        </div>
      }
      {
        isPDFFile &&
        <div className='json-preview-wrapper' >
          <PDFViewer
            pdfUrl={url}
            pdfLoader={loadingSkeleton}
          />
        </div>
      }
      {
        (isSVGFile || isJpgJpegFile || isPNGFile) &&
        <div className='svg-preview-wrapper' >
          <img className='media-image' src={url} />
        </div>
      }
      {
        isOtherFile &&
        <div className='other-file-wrapper'>
          <img className='media-image other-file-icon' src={otherFileIcon} />
        </div>
      }
      {
        isJsonFile &&
        <div className='json-preview-wrapper' >
          {
            isContentLoading
              ? loadingSkeleton
              : (
                <JsonEditor
                  content={getJsonEditorContent(stringifiedJson, mode)}
                  onChange={(content) => null}
                  headerOptionsToRemove={JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE}
                  // onRenderContextMenu={(items, context) => {
                  //   return handleContextMenuOptions({ items, context, jsonEditorReadOnly })
                  // }}
                  readOnly
                  // onChangeMode={(mode) => setMode(mode)}
                  mode={mode}
                />
              )
          }

        </div>
      }
    </div>
  )
}

export default FilePreview
